import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog/Dialog';


import TransactionMonth from './TransactionMonth';


const styles = (theme) => ({
  container: {
    maxWidth: '80%',
  },
  fullScreen: {
    paddingLeft: theme.components.register.paddingLeft,
    paddingRight: theme.components.register.paddingRight,
  },
});

export class TransactionCalendar extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  closeAndExit = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };


  render() {

    const { classes, accountIds, inDialog } = this.props;

    return (
      <>
        {inDialog &&
          <Dialog
            classes={{ paper: classes.container }}
            open
            maxWidth="lg"
            fullWidth
            show="true"
            onClose={this.closeAndExit}
            disableBackdropClick
          >
            <>
              <TransactionMonth
                onClose={this.closeAndExit}
                accountIds={accountIds}
                navFn={(txn) => { this.props.navFn(txn); this.closeAndExit(); }}
              />
            </>
          </Dialog>
        }
        {!inDialog &&
          <div className={classes.fullScreen}>
            <TransactionMonth
              onClose={this.closeAndExit}
              accountIds={accountIds}
              navFn={(txn) => { this.props.navFn(txn); this.closeAndExit(); }}
            />
          </div>
        }
      </>
    );
  }
}

TransactionCalendar.propTypes = {
  onClose: PropTypes.func,
  accountIds: PropTypes.object,
  navFn: PropTypes.func,
  inDialog: PropTypes.bool,

  classes: PropTypes.object,
};

function mapStateToProps() {
  return {
  };
}

function mapDispatchToProps() {
  return {
  };
}

// These are prop injectors
export default compose(
  withStyles(styles),  // creates this.props.classes
)(connect(mapStateToProps, mapDispatchToProps)(TransactionCalendar));

